import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_INTRODUCTION: MijnRoute = {
    path: 'notificaties-beheren',
    navigationEvent: 'toNotificatiesBeheren',
    regex: /^\/zelf-regelen\/notificaties-beheren$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent'
};
